document.addEventListener('DOMContentLoaded', () => { 
  const currentUrl = window.location.href;

  // Ne rien faire sur les pages d'accueil ou de langue
  if (
    currentUrl === 'https://www.wall-decor.fr/' ||
    currentUrl === 'https://www.wall-decor.fr/fr' ||
    currentUrl === 'https://www.wall-decor.fr/en'
  ) {
    return;
  }

  // Définition des catégories principales
  const silos = {
    'panneau-acoustique': '/collections/panneau-acoustique',
    'parement-bois': '/collections/parement-bois',
    'parement-mural': '/collections/parement-mural',
    'panneau-mural': '/collections/panneau-mural',
    'bardage-exterieur': '/collections/bardage-exterieur',
    'habillage-mur': '/pages/habillage-mur'
  };

  // Définition des sous-catégories et de leur parent
  const subCategories = {
    'panneau-acoustique-bois': {
      path: '/collections/panneau-acoustique-bois',
      parent: 'panneau-acoustique'
    },
    'plaque-en-tasseaux': {
      path: '/collections/plaque-en-tasseaux',
      parent: 'panneau-acoustique'
    },
    'panneau-tasseau-bois': {
      path: '/collections/panneau-tasseau-bois',
      parent: 'panneau-acoustique'
    },
    'panneau-acoustique-mural': {
      path: '/collections/panneau-acoustique-mural',
      parent: 'panneau-acoustique'
    },
    'panneau-mural-hydrofuge-en-tasseaux': {
      path: '/collections/panneau-mural-hydrofuge-en-tasseaux',
      parent: 'panneau-acoustique'
    },
    'panneau-mural-bois': {
      path: '/collections/panneau-mural-bois',
      parent: 'parement-bois'
    },
    'parement-bois-mural': {
      path: '/collections/parement-bois-mural',
      parent: 'parement-bois'
    },
    'lambris-bois-autocollant': {
      path: '/collections/lambris-bois-autocollant',
      parent: 'parement-bois'
    },
    'lambris-pvc': {
      path: '/collections/lambris-pvc',
      parent: 'parement-bois'
    },
    'parement-brique': {
      path: '/collections/parement-brique',
      parent: 'parement-mural'
    },
    'parement-pierre': {
      path: '/collections/parement-pierre',
      parent: 'parement-mural'
    },
    'panneau-mural-3d': {
      path: '/collections/panneau-mural-3d',
      parent: 'panneau-mural'
    },
    'panneau-mural-cuir': {
      path: '/collections/panneau-mural-cuir',
      parent: 'panneau-mural'
    },
    'tete-de-lit-matelassee': {
      path: '/collections/tete-de-lit-matelassee',
      parent: 'panneau-mural'
    },
    'carte-du-monde-deco': {
      path: '/collections/carte-du-monde-deco',
      parent: 'panneau-mural'
    },
    'mur-interieur': {
      path: '/pages/mur-interieur',
      parent: 'habillage-mur'
    },
    'deco-mur': {
      path: '/pages/deco-mur',
      parent: 'habillage-mur'
    }
  };

  /**
   * Normalise l'URL en récupérant uniquement le pathname.
   * On retire également le slash final, le cas échéant.
   */
  const normalizeUrl = (url) => {
    try {
      return new URL(url).pathname.replace(/\/$/, '');
    } catch (e) {
      // En cas d'erreur (ex: URL relative), on retire le domaine et le slash final
      return url.replace('https://www.wall-decor.fr', '').replace(/\/$/, '');
    }
  };

  /**
   * Analyse l'URL pour en extraire des informations :
   * - level : le niveau hiérarchique (1 pour la racine, puis +1 pour chaque segment)
   * - mainCategory : la catégorie principale associée
   * - subCategory : la sous-catégorie associée (le cas échéant)
   * - isProduct : indique si l'URL concerne un produit
   * - segments : les segments restants après le chemin de la catégorie
   * - path : le chemin de la catégorie ou sous-catégorie détectée
   */
  const getUrlInfo = (url) => {
    const normalizedUrl = normalizeUrl(url);
    let level = 1;
    let mainCategory = null;
    let subCategory = null;
    const isProduct = normalizedUrl.includes('/products');
    let segments = [];

    // Vérifie si l'URL correspond à une sous-catégorie
    for (const [category, info] of Object.entries(subCategories)) {
      if (normalizedUrl.startsWith(info.path)) {
        subCategory = category;
        mainCategory = info.parent;
        segments = normalizedUrl.slice(info.path.length).split('/').filter(Boolean);
        // On ajoute +1 pour tenir compte de la sous-catégorie dans le niveau
        level += segments.length + 1;
        return { level, mainCategory, subCategory, isProduct, segments, path: info.path };
      }
    }

    // Vérifie si l'URL correspond à une catégorie principale
    for (const [category, path] of Object.entries(silos)) {
      if (normalizedUrl.startsWith(path)) {
        mainCategory = category;
        segments = normalizedUrl.slice(path.length).split('/').filter(Boolean);
        level += segments.length;
        return { level, mainCategory, subCategory, isProduct, segments, path };
      }
    }

    return { level, mainCategory, subCategory, isProduct, segments, path: null };
  };

  /**
   * Détermine si un lien doit être "obfusqué" (transformé en bouton)
   * en comparant les informations extraites de l'URL du lien et de l'URL courante.
   */
  const shouldObfuscate = (linkInfo, currentUrlInfo) => {
    if (!linkInfo.mainCategory || !currentUrlInfo.mainCategory) {
      return true;
    }

    // Sur une page de catégorie principale
    if (currentUrlInfo.level === 1) {
      return linkInfo.mainCategory !== currentUrlInfo.mainCategory;
    }

    // Sur une page de sous-catégorie
    if (currentUrlInfo.level === 2 && currentUrlInfo.subCategory) {
      return linkInfo.mainCategory !== currentUrlInfo.mainCategory;
    }

    // Pour les pages plus profondes, on compare les sous-catégories
    if (currentUrlInfo.level > 2) {
      return linkInfo.subCategory !== currentUrlInfo.subCategory;
    }

    // Pour une page produit
    if (currentUrlInfo.isProduct) {
      return linkInfo.subCategory !== currentUrlInfo.subCategory;
    }

    return true;
  };

  // Sélectionne tous les liens de la navigation ciblée
  const imageLinks = document.querySelectorAll('.grandchild-nav__item.main-nav__item.relative');
  const currentUrlInfo = getUrlInfo(currentUrl);

  imageLinks.forEach(link => {
    const linkInfo = getUrlInfo(link.href);
    const obfuscate = shouldObfuscate(linkInfo, currentUrlInfo);

    if (obfuscate) {
      const url = link.href;
      // Récupère le bloc image s'il existe
      const imageDiv = link.querySelector('.media.relative.mb-2.w-full.grandchild-nav__image');
      // Utilise l'opérateur optionnel pour éviter une erreur si lastChild est nul
      const linkText = link.lastChild?.textContent || '';

      // Crée un bouton pour remplacer le lien
      const button = document.createElement('button');
      button.className = 'grandchild-nav__item main-nav__item relative';
      button.onclick = () => {
        window.location.href = url;
      };
      // Utilisation d'une chaîne de caractères pour définir le style inline
      button.style.cssText = "background: none; border: none; padding: 0; width: 100%; text-align: left; cursor: pointer; display: block;";

      if (imageDiv) {
        // Clone l'image pour la réutiliser dans le bouton
        const newImageDiv = imageDiv.cloneNode(true);
        button.appendChild(newImageDiv);
      }

      button.appendChild(document.createTextNode(linkText));
      link.parentNode.replaceChild(button, link);
    }
  });
});
